/**
 * Created by RoryHe on 2021/1/25.
 */
import {apiDELETE, apiDownload, apiGET, apiPOST, apiPUT, apiUpload} from './server';
import store from '@/store';
export const rtcPrefix = '/ept-webrtc';
// 判断接口是否成功
const codeSuccessMin = 200;
const codeSuccessMax = 300;
export const apiSuccess = (code) => Number(code) >= codeSuccessMin && Number(code) < codeSuccessMax;

export const BASE_URL = location.protocol + '//' + location.hostname + ':' + location.port;
// let path = process.env.HOST === 'pre' ? '-stage' : ''
let path = '';
export let BASE_REDIRECT_URL = BASE_URL;
export let BASE_SERVER = `${BASE_URL}/brt-mediate-scene${path}`;//请求主地址test
export let BASE_SERVER_BRT = `${BASE_URL}/brt-admin-scene${path}`;//请求主地址test

export let BASE_SERVER_SUCS = `${BASE_URL}/brt-service-sucs${path}`;//请求主地址test
export const BASE_SERVER_MEDIATION = `${BASE_URL}/brt-mediation-scene${path}`;
//保融通管理系统请求主地址test
export let BASE_SERVER_BRT_MANAGER = (type) => `${BASE_URL}/${type}/brt-admin-scene${path}`;
export let BASE_SERVER_WEBRTC = `${BASE_URL}${rtcPrefix}`;//请求主地址test
export let BASE_RTC_SERVER = process.env.NODE_ENV == 'production' ? `${location.protocol.includes('https') ? `wss` : `ws`}://${(process.env.HOST == 'prod' || process.env.HOST == 'pre') ? (location.hostname) : (location.hostname)}/notice/ws` : `ws://172.16.14.225/notice/ws`;//视频调解ws服务地址

export let UPLOAD_URL = `${BASE_URL}/tj/ept-service-file/api/v2/storage/uploadFile`;//文件上传--minIo
export let UPLOAD_PRE = `${BASE_SERVER}/api/v1/file/preUpload`;//预上传--minIo
// + (process.env.HOST == 'pre' ? '-stage' : '')

export let voiceCallSocketUrl = process.env.NODE_ENV == 'production' ? `${location.protocol.includes('https') ? `wss` : `ws`}://${(process.env.HOST == 'prod' || process.env.HOST == 'pre') ? (location.hostname + '/tj/makecall') : (location.hostname + ':' + '8190')}/ws/call` : `ws://172.16.15.117:8190/ws/call`;//外呼socket服务地址
//临时测试用
//  voiceCallSocketUrl = `wss://brt.jiulaw.cn/tj/makecall/ws/call`//外呼socket服务地址
// 公共接口
export let loginOut = `/api/v1/logout?redirectUrl=`;
export let queryByPid = (params) => apiGET(`${BASE_SERVER}/api/v1/code/queryByPid`, params);
export let getLoginUser = () => apiGET(`${BASE_SERVER}/api/v1/user/getLoginUser`, {}, false);//获取当前登录用户
// 获取当前开通功能和开通文书类型
export const getMdOpenFuncs = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/getMdOpenFuncs`, params, false);

export let getMediationTreeByActId = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/getMediationTreeByActId`, params, false);// 获取本级及下级调解机构树
export let getMediationTreeByActIdOrgan = (params) => apiGET(`${BASE_SERVER}/api/v1/organ/getMediationTreeByActId`, params, false);
export let getSubMediationTree = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/getSubMediationTree`, params, false);// 获取下级调解机构树
export let getMediatorListByActId = params => apiGET(`${BASE_SERVER}/api/v1/user/getMediatorListByActId`, params, false); // 根据机构id返回机构下调解员数据
export let getWriteRelationUsers = (params) => apiGET(`${BASE_SERVER}/api/v1/writ/template/getWriteRelationUsers`, params, true);

// 用户信息
export let changePwd = params => apiPOST(`${BASE_SERVER}/api/v1/user/changePwd`, params, false); //个人中心修改密码
export let getCaptcha = `${BASE_URL}/login/api/v1/getCaptcha?time=`;

export let doChangePhone = params => apiPOST(`${BASE_SERVER}/api/v1/user/doChangePhone`, params, false); //个人中心修改手机号
export let getSmsCode = (params, headers) => apiGET(`${BASE_URL}/login/api/v1/getSmsCode`, params, false, null, null, null, headers); //个人中心修改手机号
export let getSignInfoByUser = () => apiGET(`${BASE_SERVER}/api/v1/user/getUserSignInfoByUserId`, {}, false);//获取用户签名图片
export let saveSignInfoByUser = (params) => apiPOST(`${BASE_SERVER}/api/v1/user/saveOrUpdateUserSignInfo`, params, true);//保存用户签名信息
export let queryUserActSignInfo = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/queryUserActSignInfo`, params, true);
//修改用户回访电话
export const updateReturnCall = (params) => apiGET(`${BASE_SERVER}/api/v1/user/updateReturnCall`, params, true);
// 验证用户登陆名称是否合法
export const validateLoginName = (params) => apiGET(`${BASE_SERVER_BRT}/md/user/validateLoginName`, params, true);
// 查询当前机构及子机构下所有用户
export const getOrganAndSubOrganUserList = (params) => apiGET(`${BASE_SERVER}/api/v1/user/getOrganizationAndSubUsersByActId`, params, false);
// 查询当前用户机构所在机构树上是否有调解员角色
export const validMetorFlaginActIds = (params) => apiGET(`${BASE_SERVER}/api/v1/user/validMetorFlaginActIds`, params, false);

//分案管理
export let queryWaitDistributeBatchByCond = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/queryWaitDistributeBatchByCond`, params, true);//查询待分批次
export let delMediateByBatchId = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/deleteMediateByBatchId?batchId=${params}`, params, true);//根据批次号删除待分案件批次
// 批量删除案件
export const deleteMediates = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/deleteMediates`, params, true);
export let uploadOfflineCase = (actId, file) => apiUpload(`${BASE_SERVER}/api/v1/mediate/uploadOfflineCase?actId=${actId}`, file, false);// 线下申请调解
export let preRepaymentPlan = (params) => apiUpload(`${BASE_SERVER}/api/v1/mediate/preRepaymentPlan`, params, false);// 预设还款方案
export let deleteByBatchId = (params) => apiPOST(`${BASE_SERVER}/api/v1/prePlan/deleteByBatchId?batchId=${params}`, params, false);// 删除预设还款方案
export let downLoadErrorData = ({
                                  type, actId, errorFileId
                                }) => window.open(`${BASE_SERVER}/api/v1/mediate/downLoadErrorData?errorFileId=${errorFileId}&actId=${actId}&type=${type}`);// 在办案件统计
// 统计相关接口v2版本
export let dealWithCase = (params) => apiGET(`${BASE_SERVER}/api/v2/statistics/caseProgress`, params, false);// 案件办理情况
export let institutionalRanking = (params) => apiPOST(`${BASE_SERVER}/api/v1/statistics/institutionalRanking`, params, false);// 机构委案排名
export let workEffectiveness = (params) => apiGET(`${BASE_SERVER}/api/v1/statistics/workEffectiveness`, params, false);// 本月工作成效
// 分案列表
export let queryCommissionOrganByCond = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/queryCommissionOrganByCond`, params, false);//查询委托机构信息
export let queryBatchNameByCond = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/queryBatchNameByCond`, params, false);//根据委托机构查询批次信息
export let queryDistributeByPage = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/queryDistributeByPage`, params, true);//分页查询分案信息
export let statisticsOngoingCaseByCond = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/statisticsOngoingCaseByCond`, params);//再办案件统计
// 获取分案模式和判断当前机构是否有子机构
export const getDivisionMode = (params) => apiGET(`${BASE_SERVER}/api/v2/division/getDivisionMode`, params, false);
// 分案 - 旧接口，应该不用了
export let batchDirectAssignMediate = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediateAss/batchDirectAssignMediate`, params, true);
// 新的分案接口
export const divisionCase = (params) => apiPOST(`${BASE_SERVER}/api/v2/division`, params, true);
export let getAhRuler = (params) => apiGET(`${BASE_SERVER}/api/v1/mediateAss/getAhRuler`, params, false);// 获取机构中配置的案号规则
// 案件办理
export let queryWorkbenchOngoingBatchByUserId = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/queryWorkbenchOngoingBatchByUserId`, params, true);// 工作台分页查询在办案件批次
export let queryOngoingCaseBatchMenu = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/queryOngoingCaseBatchMenu`, params, false);// 在办批次菜单
export let queryMediateStatusByBatchName = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/queryMediateStatusByBatchName`, params, false);// 列表案件状态统计
export let queryMediateByPage = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/queryMediateByPage`, params, true);// 调解员案件查询
//签字相关
export let getAutographDetail = (params) => apiPOST(`${BASE_SERVER}/api/v1/statistics/initiateSignatureDocStatistics`, params, true);//获取发起签字详情
export let initiateSignature = (params, headers) => apiPOST(`${BASE_SERVER}/api/v1/task/initiateSignature`, params, true, null, null, null, headers);//发起签字任务
//批量文书送达
export let getBatchDocDetail = (params) => apiPOST(`${BASE_SERVER}/api/v1/statistics/signingStatistics`, params, true);
export let deliverDoc = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/deliveryDoc`, params, true);//创建批量文书送达任务
//案件详情
export let getMediateDetail = (params, v = 'v3') => {
  let queryStr = '';
  Object.keys(params)
    .forEach(key => {
      queryStr += `${key}=${params[key]}&`;
    });
  return apiPOST(`${BASE_SERVER}/api/${v}/mediate/queryMediateInfoByMediateId?${queryStr}`, {}, true);//调解案件详情查询
};
export let getMediateDetailV2 = (params, v = 'v3') => {
  return apiPOST(`${BASE_SERVER}/api/${v}/mediate/queryMediateInfoByMediateIdV2`, params, true);//调解案件详情查询
};
export let saveMediate = (params, v = 'v3') => apiPOST(`${BASE_SERVER}/api/${v}/mediate/saveOrUpdate`, params, true);//保存调解案件信息
export let batchGenId = (params) => apiGET(`${BASE_SERVER}/api/v1/batchGenId`, params, false);// 批量获取id
export let genId = (params) => apiGET(`${BASE_SERVER}/api/v1/genId`, params, false);// 单个获取id
export let fileUpdate = (params, isShowLoading) => {
  if (isShowLoading == undefined || isShowLoading == null) {
    isShowLoading = true;
  }
  return apiPOST(`${BASE_SERVER}/api/v1/material/saveOrUpdate`, params, isShowLoading);
}; //附件保存
export let getCaseLog = (params) => apiGET(`${BASE_SERVER}/api/v1/log/getMediateEventLog`, params, true);// 获取案件日志
export let queryCodeList = (params) => apiPOST(`${BASE_SERVER}/api/v1/code/queryCodeList`, params, false);// 获取单值代码


// 标签信息
export let getDefaultCheck = (params) => apiGET(`${BASE_SERVER}/api/v1/tag/getDefaultCheck`, params, false);//查询用户默认筛选项
export let getTagWithStatus = (params) => apiGET(`${BASE_SERVER}/api/v1/tag/getTagWithStatus`, params, false);//根据案件状态获取标签
export let setDefaultCheck = (params) => apiPOST(`${BASE_SERVER}/api/v1/tag/setDefaultCheck`, params, false);//设置默认筛选
export let addDIYTag = (params) => apiGET(`${BASE_SERVER}/api/v1/tag/addDIYTag`, params, false);// 增加自定义标签
export let delDIYTag = (params) => apiGET(`${BASE_SERVER}/api/v1/tag/delDIYTag`, params, false);// 删除自定义标签
export let getAllTag = (params) => apiGET(`${BASE_SERVER}/api/v1/tag/getAllTag`, params, false);// 查询所有标签
export let updateTag = (params) => apiPOST(`${BASE_SERVER}/api/v1/tag/updateTag`, params, false);// 更新标签

// 任务相关接口
export let queryTaskTrackingByUserId = (params) => apiGET(`${BASE_SERVER}/api/v1/task/queryTaskTrackingByUserId`, params, false);//查询正在执行的任务类型列表
export let queryTaskDetailByCond = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/queryTaskDetailByCond`, params, true);//查询任务明细
export let statisticsTaskByUserId = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/statisticsTaskByUserId`, params, true);//查询任务
export let resend = (params) => apiGET(`${BASE_SERVER}/api/v1/sms/resend`, params, true);//重推
export let batchDeleteTaskById = (params, taskType) => apiPOST(`${BASE_SERVER}/api/v1/task/batchDeleteTaskById?taskType=${taskType}`, params, false);//忽略任务
export let batchDeleteTaskDetailById = (params, taskType) => apiPOST(`${BASE_SERVER}/api/v1/task/batchDeleteTaskDetailById?taskType=${taskType}`, params, false);//忽略任务详情
export let resendSms = (params, headers, actId = '') => apiPOST(`${BASE_SERVER}/api/v1/task/resendSms?actId=${actId}`, params, false, null, null, null, headers);//重新发送
export let unpack = (taskId) => apiGET(`${BASE_SERVER}/api/v1/download/unpack?taskId=${taskId}`, '', false);//打包下载
export let updatePhone = ({
                            detailId, phone
                          }) => apiPOST(`${BASE_SERVER}/api/v1/task/updatePhone?detailId=${detailId}&phone=${phone}`, '', false);//更新手机号

/**
 *
 * @param params:{
 "actId": "string",机构id
 "batchId": "string",批次编号
 "cond": "string",查询条件
 "excludeIds": [过滤集合，不进入任务队列的调解主键编号
 "string"
 ],
 "isFilterResult": true,是否为筛选结果：true：是，false:否
 "mediateIds": [isFilterResult=false生效，调解主键编号
 "string"
 ],
 "status": 0,状态
 "tagIds": [标签
 "string"
 ],
 "userId": "string"
 }
 * @return {Promise | Promise<unknown>}
 */
export let createVoiceCallTask = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/createVoiceCallTask`, params, true);//创建任务队列
export let saveTaskList = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/saveOrUpdate`, params, true);//保存任务队列状态
export let updateVoiceCallTask = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/updateVoiceCallDetailTaskById?${params}`, {}, false);//更新外呼任务信息
export let sendSms = (params, headers) => apiPOST(`${BASE_SERVER}/api/v1/task/sendSms`, params, false, null, null, null, headers);//发送短信
export let createSingleVoiceCallTask = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/createSingleVoiceCallTask`, params, true);//创建单个外呼的任务队列
export let signature = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/signature`, params, true);
// 导出短信明细
export const exportSmsInfo = (taskId) => apiDownload(`${BASE_SERVER}/api/v1/sms/export?taskId=${taskId}`, {}, true);


//呼叫中心相关接口
export let getPartyUserByMediateId = (mediateId) => apiGET(`${BASE_SERVER}/api/v1/mediate/queryPartyByMediateId?mediateId=${mediateId}`, {}, false);//根据调解id获取案件当事人信息
export let queryVideoPartyUsers = (mediateId) => apiGET(`${BASE_SERVER}/api/v1/video/queryVideoPartyUsers?mediateId=${mediateId}`, {}, false);//根据调解id获取案件当事人信息
export let getSeatInfo = (actId) => apiGET(`${BASE_SERVER}/api/v1/call/getSeatInfo`, {actId}, false);//获取初始化呼叫资源信息
export let revokeSeat = (params) => apiGET(`${BASE_SERVER}/api/v1/call/revokeSeat`, params, false);//释放坐席
export let saveCallInfo = (params) => apiPOST(`${BASE_SERVER}/api/v1/call/v1/saveCallInfo`, params, false);//保存坐席通话记录
export let saveCallRepayPlan = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/saveRepayPlan`, params, true);//保存呼叫中心的沟通记录和还款方案
export let statisticsVoiceCallByTaskId = (params) => apiPOST(`${BASE_SERVER}/api/v1/statistics/statisticsVoiceCallByTaskId`, params, false);//获取外呼总数
// 获取当前未关联的通话记录
export const getCallInfoList = (params) => apiPOST(`${BASE_SERVER}/api/v1/call/getCallInfoList`, params, true);
// 获取当前坐席类型
export const getCallSeatType = (params) => apiGET(`${BASE_SERVER}/api/v1/call/getType`, params, true);

// 保融通自有调解平台
export let getSmsTemplateListByActId = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/getSmsTemplateListByActId`, params, false);//根据机构id获取短信模板信息
export let queryMediateDebtByMediateId = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/queryMediateDebtByMediateId`, params, false);//查询案件债务信息和调解记录以及达成方案
export let queryCaseElement = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/queryCaseElement`, params, false);//查询案件债务信息
export let saveOrUpdateRepayPlan = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/saveOrUpdateRepayPlan`, params, false);//还款方案保存
export let registRepayPlanStage = (params) => apiUpload(`${BASE_SERVER}/api/v1/mediate/registRepayPlanStage`, params, false);//
export let batchRegistRepayStage = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/batchRegistRepayStage`, params, false);//批量保存还款记录登记
export let downloadRepayStageExcel = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/downloadRepayStageExcel`, params, false);// 下载还款记录数据(只导出本页的)
export let uploadRepayStageExcel = (actId, batchId, file) => apiUpload(`${BASE_SERVER}/api/v1/mediate/uploadRepayStageExcel?actId=${actId || ''}&batchId=${batchId || ''}`, file, false);// 还款记录数据导导入
export let getPreRepaymentPlanByBatchId = (batchId) => apiPOST(`${BASE_SERVER}/api/v1/mediate/getPreRepaymentPlanByBatchId?batchId=${batchId}`, {}, false);// 预设还款方案查询
export let getStageListByMediateId = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/getStageListByMediateId`, params, false);//还款计划列表查询
export let getFileUrl = (params) => apiGET(`${BASE_SERVER}/api/v1/file/getFileUrl`, params, false);//预览
export let getCallFileUrlByFileId = (params) => apiGET(`${BASE_SERVER}/api/v1/file/getCallFileUrlByFileId`, params, false);
// 调解视频播放预览
export let getVideoFileUrl = (params) => apiGET(`${BASE_SERVER}/api/v1/video/getVideoFileUrl`, params, false);

// 文件预览船新版本
export let getFileUrlByCaseIdAndFilePk = (params) => apiGET(`${BASE_SERVER}/api/v1/file/getFileUrlByCaseIdAndFilePk`, params, false);
// 文件预览司法确认版本
export let getJudicialFileUrl = (params) => apiGET(`${BASE_SERVER}/api/v1/file/getJudicialFileUrl`, params, false);
export let statisticsMediatorCaseByCond = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/statisticsMediatorCaseByCond`, params, false);//
export let archiveMediates = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/archiveMediates`, params, true);//案件归档处理
export let archiveStatistics = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/archiveStatistics`, params, true);//归档弹窗数据
// 二维码相关接口
export let genQrCode = (params) => apiGET(`${BASE_SERVER}/api/v2/qrcode/genQrCode`, params, false);//生成二维码图片
export let getQrCodeResult = (params) => apiGET(`${BASE_SERVER}/api/v1/qrcode/getQrCodeResult`, params, false);//查询签名结果

//批量文书上传相关接口
export let getBatchUploadList = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/queryMatchCaseFirst`, params, false);
export let getBatchUploadCaseInfo = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/queryMatchCaseSecond`, params, false);
export const downLoadBatchUploadTemp = (params) => apiGET(`${BASE_SERVER}/api/v1/download/example`, params, false);//获取模版下载地址

// 机构相关接口
export let getAllAccountTreeNode = (params) => apiGET(`${BASE_SERVER_BRT}/mediation/getAllAccountTreeNode`, params, true);
export let getAllAccountTreeNode2 = (params) => apiPOST(`${BASE_SERVER}/mediation/getAllAccountTreeNode`, params, false);
export let getPageUserList = (params) => apiPOST(`${BASE_SERVER_BRT}/mediation/getPageUserList`, params, true); // 分页获取机构用户
export let getUserInfoByActId = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/call/getUserInfoByActId`, params, true); // 分页获取机构用户
export let getOneMediationUser = (params) => apiGET(`${BASE_SERVER_BRT}/mediation/getOneMediationUser`, params, true); // 获取单个用户
export let getOneMediation = (params) => apiGET(`${BASE_SERVER_BRT}/mediation/getOneMediation`, params, true); //
export let resetUserPwd = (params) => apiPOST(`${BASE_SERVER_BRT}/md/user/resetUserPwd`, params, true); // 密码重置
export let validateIdNumShow = (params) => apiGET(`${BASE_SERVER}/api/v1/user/validateIdNumShow`, params, true);
export let validateMonitorIdNumShow = (params) => apiGET(`${BASE_SERVER}/api/v1/user/validateMonitorIdNumShow`, params, true);
export let updateMdUserValid = (params) => apiPOST(`${BASE_SERVER_BRT}/md/user/updateMdUserValid`, params, true); // 禁用和启用
export let saveMediationUser = (params) => apiPOST(`${BASE_SERVER_BRT}/md/user/saveMediationUser`, params, true); // 保存机构用户
export let getDivisionModeBrt = (params) => apiGET(`${BASE_SERVER_BRT}/mediation/getDivisionMode`, params, true); //

//动态配置相关接口
export let getDocSignConfig = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/getDocSignConfigByActId`, params, false);//根据机构获取文书签名配置
// 获取单位信息模板列表
export let getPlaintiffConfigInfoList = (params) => apiGET(`${BASE_SERVER}/api/v1/organ/getPlaintiffConfigInfoList`, params, false);
// 单位信息模板保存
export let saveMdOrgInfoConfig = (params) => apiPOST(`${BASE_SERVER}/api/v1/organ/saveMdOrgInfoConfig`, params, true);
// 单位信息模板删除
export let delPlaintiffConfigInfo = (params) => {
  let queryStr = '';
  Object.keys(params)
    .forEach(key => {
      queryStr += `${key}=${params[key]}&`;
    });
  return apiPOST(`${BASE_SERVER}/api/v1/organ/delPlaintiffConfigInfo?${queryStr}`, params, false);
};

// 批量删除案件
export let batchDeleteByAgent = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/agent/batchDeleteMediateById`, params, true);
// 根据批次删除调解案件
export let batchDeleteMediateByBatchId = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/agent/batchDeleteMediateByBatchId`, params, true);
// 首页统计
export let getAgentChannelHomePageCountDto = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/agent/getAgentChannelHomePageCountDto`, params, true);
// 首页查询
export let getAgentChannelHomePageForPage = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/agent/getAgentChannelHomePageForPage`, params, true);
// 列表详情
export let queryMediateInfoByMediateIdV2 = (params, v = 'v1') => apiPOST(`${BASE_SERVER}/api/${v}/mediate/agent/queryMediateInfoByMediateIdV2`, params, true);
// 案件保存
export let saveOrUpdate = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/agent/saveOrUpdate`, params, true);
// 获取当前用户的金融机构列表
export let getAccountListByUserId = (params) => apiGET(`${BASE_SERVER}/api/v1/organ/getAccountListByUserId`, params, true);
// 根据id提交案件
export let submitCaseById = (params, query, v = 'v1') => apiPOST(`${BASE_SERVER}/api/${v}/mediate/agent/submitCaseById${query}`, params, true);
// 根据批次id提交案件
export let submitCaseByBatchId = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/agent/submitCaseByBatchId`, params, true);
// 统计
export let getAccountMdWalletRemain = (params) => apiGET(`${BASE_SERVER}/api/v1/organ/getAccountMdWalletRemain`, params, true);
// 文件合成相关
// 批量获取文件缩略地址
export let getFilePreviewUrls = (params) => apiPOST(`${BASE_SERVER}/api/v1/file/getFilePreviewUrls`, params, true);
// 提交合成
export let fileMerge = (params) => apiPOST(`${BASE_SERVER}/api/v1/merge`, params, true);
// 定时获取结果
export let getFileIdByTaskId = (params) => apiGET(`${BASE_SERVER}/api/v1/getFileIdByTaskId`, params, true);


// 快捷录入
export let getMediationInfoByActId = (params) => apiGET(`${BASE_SERVER}/api/v1/organ/getMediationInfoByActId`, params, false);//根据机构id获取调解机构列表
export let checkActIdV3Enabled = (params) => apiGET(`${BASE_SERVER}/api/v1/organ/checkActIdV3Enabled`, params, false);//查询调解机构是否开通3.0
export let getPlaintiffTemplate = (params) => apiGET(`${BASE_SERVER}/api/v1/organ/getPlaintiffTemplate`, params, true);//根据机构id获取配置的模板列表
export let uploadFile = (params, file) => apiUpload(`${BASE_SERVER}/api/v1/online/mediate/import${params}`, file, false);// 线上委案案件导入接口
export let onlineGetTemplateByUserId = (params) => apiGET(`${BASE_SERVER}/api/v1/online/mediate/getTemplateByUserId`, params, false);//根据用户编号获取模板信息

//材料批量上传接口（后台执行匹配逻辑）
export let fileOrDirMatch = (params) => apiPOST(`${BASE_SERVER}/api/v1/match/fileDir/async`, params, false, null, null, '60000');//开启文件／文件夹匹配任务
export let zipFileMatch = (params) => apiPOST(`${BASE_SERVER}/api/v1/match/zipFile/async`, params, false, null, null, '60000');//开启zip文件匹配任务
export let queryFileMatchTask = (params) => apiGET(`${BASE_SERVER}/api/v1/task/getProgressByTaskId`, params);//查询文件匹配进度
export let queryFileMatchTaskStatus = (params) => apiGET(`${BASE_SERVER}/api/v1/task/getTaskStatusByTaskId`, params);//查询文件匹配任务状态
export let updateFileMatchTaskStatus = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/updateTaskStatusByTaskId?taskId=${params}`, {});//更新文件匹配任务
export let queryFileMatchTaskDetails = (params) => apiPOST(`${BASE_SERVER}/api/v1/match/queryByPage`, params);//分页查询任务成功失败结果列表
export let queryCaseCount = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/batch/count`, params);//统计批次中案件数量，如果数量为1，返回案件编号
export let getCurrentFileMatchTask = () => apiGET(`${BASE_SERVER}/api/v1/task/existProcessingMatchTask`);//查询当前用户是否有正在执行的文件匹配任务
export let downLoadTaskDetail = `${BASE_SERVER}/api/v1/downLoadTaskDetailByTaskId`;//下载任务匹配错误详情

/*
* 调解分案信息
* */
//审核案件
export let auditCase = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediateAss/auditCase`, params, true);
// 获取分案状态的统计数据
// 获取分案状态统计数据
export const caseVolumeStatistics = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/caseVolumeStatistics`, params, true);
// v2.2.0新增接口
//批量文书打包
export let batchDocPackLoad = (params) => apiPOST(`${BASE_SERVER}/api/v1/pack/download`, params, true);

// 视频调解相关
// 保存或者更新视频调解
export let saveOrUpdateVideoRoom = (params) => apiPOST(`${BASE_SERVER}/api/v1/video/saveOrUpdateVideoRoom`, params, true);
// 根据id取消一个视频调解
export let cancelVideoRoomById = (params) => {
  let queryStr = '';
  Object.keys(params)
    .forEach(key => {
      queryStr += `${key}=${params[key]}&`;
    });
  return apiPOST(`${BASE_SERVER}/api/v1/video/cancelVideoRoomById?${queryStr}`, params, false);
};
// 根据id查询一个视频调解
export let getVideoRoomById = (params) => apiGET(`${BASE_SERVER}/api/v1/video/getMdtorVideoRoomById`, params, true);
// 查询一个案件的文书列表
export let queryDocFileList = (params) => apiGET(`${BASE_SERVER}/api/v1/material/queryDocFileList`, params, false);
// 发起签字
export let videoSignature = (params) => apiPOST(`${BASE_SERVER}/api/v1/video/initiateSignature`, params, true);
// 文件共享
export let sharedFile = (params) => apiPOST(`${BASE_SERVER}/api/v1/video/sharedFile`, params, true);
// 取消共享
export let unShare = (params) => apiPOST(`${BASE_SERVER}/api/v1/video/unShare`, params, true);
// 邀请其他人参加视频调解
export let inviteAttendVideoRoom = (params) => apiPOST(`${BASE_SERVER}/api/v1/video/inviteAttendVideoRoom`, params, true);
// 根据主键id删除调解文件 todo 不用了。
export let deleteMediateFileById = (params) => {
  let queryStr = '';
  Object.keys(params)
    .forEach(key => {
      queryStr += `${key}=${params[key]}&`;
    });
  return apiPOST(`${BASE_SERVER}/api/v1/material/deleteMediateFileById?${queryStr}`, params, true);
};
// 根据主键ID删除调解文件，新接口，增加了caseId
export let deleteMediateFileByIdAndCaseId = (params) => {
  let queryStr = '';
  Object.keys(params)
    .forEach(key => {
      queryStr += `${key}=${params[key]}&`;
    });
  return apiPOST(`${BASE_SERVER}/api/v1/material/deleteMediateFileByIdAndCaseId?${queryStr}`, params, true);
};
// 获取入会签名
export let getSignature = (params) => apiGET(`${BASE_SERVER}/api/v1/video/auth/signature`, params, true);
// 单个调解案件视频调解记录分页查询
export let getCurMdCaseVideoRoomPage = (params) => apiPOST(`${BASE_SERVER}/api/v1/video/getCurMdCaseVideoRoomPage`, params, true);
// 新增批次信息
export let saveMediateBatch = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/batch/saveMediateBatch`, params, true);
// 手动添加案件弹框 -》获取案件批次列表
export const queryLessThanThousand = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/queryLessThanThousand`, params, true);

// 批次办结操作
export const batchFinish = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/finish`, params, true);
// 批次退回
export const rollback = (params) => apiPOST(`${BASE_SERVER}/api/v2/division/rollback`, params, true);
/**
 * ********************   webrtc场景层服务   start  **************************
 */
// 获取当前参会用户信息
export const rtcUser = (params) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/user`, params, true);

// 获取当前参会用户信息
export const rtcUserList = (params) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/user/list`, params, false);

// 获取加入房间的token
export const rtcSignature = (params) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/auth/signature`, params, true);
export const rtcSetToken = (params) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/home`, params, true);

// 参会人是否是主持人
export const rtcModerator = (params) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/moderator`, params, true);

// 获取当前登录用户的权限字
export const rtcRight = (roomId, params) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/right?roomId=${roomId}`, params, true);

// 校验参会人是否拥有指定权限
export const rtcRightPost = (useId, roomId, params) => apiPOST(`${BASE_SERVER_WEBRTC}/api/v1/right/user?user=${useId}&roomId=${roomId}`, params, false);

// 关闭会议室
export const rtcMeetingClose = (params) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/meeting/close?roomId=${params.roomId}&transcode=${params.transcode}`, {}, true);

// 更新合流画面 更新track
export const rtcStreamUpdate = (params, showLoading) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/stream/update?roomId=${params.roomId}`, params, showLoading, '正在切换画面，请稍后');

// 更新水印图片
export const rtcWatermark = (roomId, params) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/stream/watermark?roomId=${roomId}`, params, false);

// 切换合流画面，在合流画面中增加指定图片
export const rtcFrameImage = (params) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/meeting/frame/image`, params, true);

// 踢出参会人员
export const rtcMeetingKick = (params) => apiDELETE(`${BASE_SERVER_WEBRTC}/api/v1/meeting/kick?roomId=${params.roomId}&user=${params.userId}`, params.tracks, true);

// 离开房间
export const rtcMeetingLeave = (params, data) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/meeting/leave?attendeeId=${params.attendeeId}&roomId=${params.roomId}`, data, true);

// 暂停直播
export const rtcMeetingPause = (params) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/live/pause?roomId=${params.roomId}`, params, true);

// 恢复直播
export const rtcLiveResume = (params) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/live/resume?roomId=${params.roomId}`, params, true);

// 开始直播
export const rtcLiveStart = (params) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/live/start?roomId=${params.roomId}`, params, true, '正在启动录制，请稍后');

// 结束直播
export const rtcLiveEnd = (roomId) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/live/stop?roomId=${roomId}`, true);

// 直播状态
export const rtcLiveStatus = (roomId) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/live/status?roomId=${roomId}`, true);

// 直播配置
export const rtcLiveConfig = (params) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/meeting/config`, params, false);

// 查询场景图片生成进度
export const rtcPictureStatus = (params) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/picture/status`, params, true);

// 创建会议图片
export const rtcPictureCreate = (params) => apiPOST(`${BASE_SERVER_WEBRTC}/api/v1/picture/create`, params, true);

// 创建会议图片
export const rtcPictureCreateTemplate = (params) => apiPOST(`${BASE_SERVER_WEBRTC}/api/v1/picture/template/create`, params, false);

// 删除会议图片
export const rtcPictureDel = (params) => apiDELETE(`${BASE_SERVER_WEBRTC}/api/v1/picture/del?id=${params.id}`, params, true);

// 根据房间id查询会议图片列表
export const rtcPictureList = (params) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/picture/list`, params, false);

// 修改会议图片
export const rtcPictureModify = (params) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/picture/modify`, params, true);

// 批量修改会议图片
export const rtcPictureModifyBatch = (params) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/picture/modify/batch`, params, false);

// 上传会议图片回调
export const rtcPictureUpload = (params) => apiPOST(`${BASE_SERVER_WEBRTC}/api/v1/picture/upload`, params, true);

// 查询房间自定义数据
export const rtcCustomData = (params) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/data`, params, false);

// 添加房间自定义数据
export const rtcCustomDataAdd = (params) => apiPUT(`${BASE_SERVER_WEBRTC}/api/v1/data/add?roomId=${params.roomId}`, params, true);

// 获取会议服务链接地址
export const rtcMeetingServerUrl = (params) => apiGET(`${BASE_SERVER_WEBRTC}/api/v1/data/meeting/url`, params, true);

/**
 * *********************   webrtc场景层服务   end  *******************************
 */
// 文书模板相关
// 获取文书模板列表
export const getWritTemplateListUrl = `${BASE_SERVER}/api/v1/writ/template/list`;
export const getWritTemplateList = (params) => apiPOST(getWritTemplateListUrl, params, true);
// 获取某个调解机构下已开通的文书类型列表
export const getDocTypesByActIdUrl = `${BASE_SERVER}/api/v1/writ/template/getDocTypesByActId`;
export const getDocTypesByActId = (params) => apiGET(getDocTypesByActIdUrl, params, true);
// 获取当前调解机构下的框架模板
export const getTemplateFrameUrl = `${BASE_SERVER}/api/v1/writ/template/frame`;
export const getTemplateFrame = (params) => apiGET(getTemplateFrameUrl, params, true);
// 新建模板保存
export const saveTemplateFormUrl = `${BASE_SERVER}/api/v1/writ/template/save`;
export const saveTemplateForm = (params) => apiPOST(saveTemplateFormUrl, params, true);
// 模板删除
export const deleteTemplateUrl = `${BASE_SERVER}/api/v1/writ/template/delete`;
export const deleteTemplate = (params) => apiGET(deleteTemplateUrl, params, true);
// 模板状态更新
export const updateTemplateStatusUrl = `${BASE_SERVER}/api/v1/writ/template/updateStatus`;
export const updateTemplateStatus = (params) => apiPOST(updateTemplateStatusUrl, params, true);
// 判断模板是否存在
export const hasExistTemplateUrl = `${BASE_SERVER}/api/v1/writ/template/hasExistTemplate`;
export const hasExistTemplate = (params) => apiPOST(hasExistTemplateUrl, params, true);
export const getPublishActByMdActId = (params) => apiGET(`${BASE_SERVER}/api/v1/writ/template/getPublishActByMdActId`, params, true);
export const getAgentRelationUsersByActId = (params) => apiGET(`${BASE_SERVER}/api/v1/user/getAgentRelationUsersByActId`, params, true);
// 批量生成文书查询模板
export const queryMediateTemplate = (params) => apiPOST(`${BASE_SERVER}/api/v1/writ/template/queryMediateTemplate`, params, true);
// 批量文书生成预览
export const createMaterialPreview = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/createMaterialPreview`, params, true);
// 批量文书生成
export const createMaterial = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/createMaterial`, params, true);
// 根据案件查询文书详情
export const queryMediateFile = (params, v = 'v3') => apiPOST(`${BASE_SERVER}/api/${v}/mediate/queryMediateFile`, params, true);
// 单个文书生成
export const createMaterialSingle = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/createMaterialSingle`, params, true);
// 导出模板
export const exportTemplate = (params) => apiGET(`${BASE_SERVER}/api/v1/writ/template/exportTemplate`, params, true);
// 导入模板
export const importTemplate = (relationId, file) => apiUpload(`${BASE_SERVER}/api/v1/writ/template/importTemplate?relationId=${relationId}`, file, true);


/* 信息配置控制层 */
// 根据机构id获取案件信息配置项
export const getMsgConfigByActId = (params) => apiGET(`${BASE_SERVER}/msgconfig/getMsgConfigByActId`, params, true);
export const getFirstLevelAdminUserName = (params) => apiGET(`${BASE_SERVER}/api/v1/user/getFirstLevelAdminUserName`, params, true);
// 保存或更新案件信息配置项
export const saveMsgConfig = (params) => apiPOST(`${BASE_SERVER}/msgconfig/saveMsgConfig`, params, true);
export const updateDefaultMsgConfig = (params) => apiPOST(`${BASE_SERVER}/msgconfig/updateDefaultMsgConfig`, params, true);

// 线上委案
export let getTemplateFieldUrl = (params) => apiGET(`${BASE_SERVER}/api/v1/online/mediate/getTemplateFieldUrl`, params, false);//获取模版下载地址

/* 调解案件信息查询 */
export let mediateDownLoad = (params) => apiDownload(`${BASE_SERVER}/api/v3/mediate/downLoad`, params, false);
export let paymendDownLoad = (params) => apiDownload(`${BASE_SERVER}/api/v3/mediate/paymendDownLoad`, params, false);
export let mediateSearch = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/search`, params, true);
export let selectCommissionOrganList = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/selectCommissionOrganList`, params, false);
export let selectMediatorList = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/selectMediatorList`, params, false);
export let searchOptions = (params) => apiGET(`${BASE_SERVER}/api/v3/mediate/searchOptions`, params, false);

// 站内信相关
// 获取站内信列表
export const getMessageQueryByPage = (params) => apiPOST(`${BASE_SERVER}/instation/message/queryByPage`, params, false);
// 获取所属人站内信列表
export const getMessageQueryOwnerByPage = (params) => apiGET(`${BASE_SERVER}/instation/message/queryOwnerPage`, params, false);
// 站内信下线
export const setMessageOffline = (params) => apiGET(`${BASE_SERVER}/instation/message/offline`, params, false);
// 站内信发布
export const setMessagePublish = (params) => apiGET(`${BASE_SERVER}/instation/message/publish`, params, false);
// 站内信删除
export const setMessageDelete = (params) => apiGET(`${BASE_SERVER}/instation/message/delete`, params, false);
// 获取机构列表
export const queryAccountList = (params) => apiGET(`${BASE_SERVER}/api/v1/organ/queryAccountList`, params, false);
// 查询当前机构下的角色和用户
export const getRoleUserInfo = (params) => apiGET(`${BASE_SERVER}/api/v1/user/getRoleUserInfo`, params, false);
// 站内信保存
export const messageSaveOrUpdate = (params) => apiPOST(`${BASE_SERVER}/instation/message/saveOrUpdate`, params, true);


//文书编辑模块
/**
 * 查询文书编辑所需标签
 */
export let queryLabelDto = (curActId, planType, caseReason) => apiGET(`${BASE_SERVER}/api/v1/label/findBusinessLabelDto?curActId=${curActId}&planType=${planType || ''}&caseReason=${caseReason || ''}`, {}, false);
//保存文书生成模版
export let saveDocTemp = (params) => apiPOST(`${BASE_SERVER}/api/v1/writ/template/saveOrUpdateTemplate`, params, true);
//获取文书模版根据templateId
export let getDocTemp = (relationId) => apiGET(`${BASE_SERVER}/api/v1/writ/template/getContent?relationId=${relationId}`, {}, true);
//预览文书模版
export let previewDocTemp = (params) => apiPOST(`${BASE_SERVER}/api/v1/writ/template/getPreviewUrl`, params, true);
//发布文书模版  status:1编辑，2发布
export let publishDocTemp = (relationId, isOverride, role) => apiPOST(`${BASE_SERVER}/api/v1/writ/template/updateStatus`, {
  isOverride: isOverride, relationId: relationId, role, status: 2
}, true);

// 调解云图相关
// 获取云图接口详情
export const cloudPictureOverview = (params) => apiGET(`${BASE_SERVER}/api/v1/statistics/cloudPictureOverview`, params, false);
// 保存云图数据
export const saveCloudPicture = (params) => apiPOST(`${BASE_SERVER}/api/v1/statistics/saveCloudPicture`, params, false);
// 云图配置页面获取云图详情
export const getCloudPictureEctype = (params) => apiGET(`${BASE_SERVER}/api/v1/statistics/getCloudPictureEctype`, params, false);


// 司法确认登记相关
// 获取统计司法状态数量
export const judicialStatusCount = (params) => apiPOST(`${BASE_SERVER}/api/v2/statistics/judicialStatusCount`, params, false);
// 保存司法确认登记
export const judicialRegisterSaveOrUpdate = (params) => apiPOST(`${BASE_SERVER}/api/v1/judicialRegister/saveOrUpdate`, params, false);
// 保存诉讼登记
export const litigationSaveOrUpdate = (params) => apiPOST(`${BASE_SERVER}/api/v1/litigation/saveOrUpdate`, params, false);


// 缴费登记相关
// 获取当事人列表
export const getMediationPartiesByMediateId = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/getMediationPartiesByMediateId`, params, false);
// 保存缴费登记信息
export const savePaymentOrUpdate = (params) => apiPOST(`${BASE_SERVER}/api/v1/payment/savePaymentOrUpdate`, params, false);
// 查询缴费登记信息
export const getPaymentByMediateId = (params) => apiGET(`${BASE_SERVER}/api/v1/payment/getPaymentByMediateId`, params, false);
// 获取缴费信息和司法确认信息
export const getPaymentAndJudicialInfoByMediateId = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/getPaymentAndJudicialInfoByMediateId`, params, false);

// 申请司法确认
export let getPowerList = (params, isShowLoading) => apiGET(`${BASE_URL}/brt-scene/account/v2/getCurActRightKeys`, params, isShowLoading);//获取权限list
export let getCourtInfoByUserId = (params) => apiGET(`${BASE_URL}/brt-scene/getCourtInfoByUserId`, params, false);//获取法院list和对接的系统
export let getPlaintiffConfigInfoList2 = (params) => apiGET(`${BASE_URL}/brt-scene/config/v1/getPlaintiffConfigInfoList`, params);
export let getPlaintiffUnionConfig = (params) => apiGET(`${BASE_URL}/brt-scene/config/v1/getPlaintiffUnionConfig`, params);
export let judicialPageCount = (params) => apiPOST(`${BASE_SERVER}/api/v1/judicial/confirmation/judicialPageCount`, params);
export let judicialPage = (params) => apiPOST(`${BASE_SERVER}/api/v1/judicial/confirmation/judicialPage`, params, true);
export let applyJudicialConfirma = (params) => apiPOST(`${BASE_SERVER}/api/v1/judicial/confirmation/applyJudicialConfirma`, params, true);
export let queryJudicialInfoByBseId = (params) => apiGET(`${BASE_SERVER}/api/v1/judicial/confirmation/queryJudicialInfoByBseId`, params, true);
export let queryJudicialInfoByCaseId = (params) => apiGET(`${BASE_SERVER}/api/v1/judicial/confirmation/queryJudicialInfoByCaseId`, params, true);
export let updateJudicialInfo = (params) => apiPOST(`${BASE_SERVER}/api/v1/judicial/confirmation/updateJudicialInfo`, params);
export let updateJudicialCaseInfo = (params) => apiPOST(`${BASE_SERVER}/api/v1/judicial/confirmation/updateJudicialCaseInfo`, params);
export let submitJudicialInfo = (params) => apiPOST(`${BASE_SERVER}/api/v1/judicial/confirmation/submitJudicialInfo`, params);
export let queryCodeListByCrtId = (params) => apiPOST(`${BASE_SERVER}/api/v1/code/queryCodeListByCrtId`, params);

// 录音绑定相关
// 根据调解员编号分页查询调解案件
export const queryCurrentMediatorCase = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/queryCurrentMediatorCase`, params, true);
// 绑定通话关系
export const bindCallRelation = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/bindCallRelation`, params, true);

// 文书签收送达相关
export const queryByPage = (params) => apiPOST(`${BASE_SERVER}/api/v1/delivery/agent/queryByPage`, params, true);
// 获取单个预览地址
export const getDocUrlByDeliveryId = (params) => apiGET(`${BASE_SERVER}/api/v1/delivery/agent/getDocUrlByDeliveryId`, params, true);
// 代理人批量打包
export const batchPack = (params) => apiPOST(`${BASE_SERVER}/api/v1/delivery/agent/batchPack`, params, true);
// 获取压缩包下载地址
export const getTaskZipUrlByTaskId = (params) => apiGET(`${BASE_SERVER}/api/v1/delivery/agent/getTaskZipUrlByTaskId`, params, true);
// 获取代理人文书打包状态，未创建任务返回null
export const getAgentDocPackStatus = (params) => apiGET(`${BASE_SERVER}/api/v1/task/getAgentDocPackStatus`, params, true);
// 忽略任务
export const updateStatusById = ({
                                   id, status
                                 }) => apiPOST(`${BASE_SERVER}/api/v1/task/updateStatusById?id=${id}&status=${status}`, {}, true);

// 获取文书签收列表
export const getMdPostList = (params) => apiPOST(`${BASE_URL}/brt-scene/getMdPostList`, params, true);
// 获取文书签收详情 查看弹框接口
export const getPostDetailList = (params) => apiPOST(`${BASE_URL}/brt-scene/getPostDetailList`, params, true);
// 下载文书
export let downLoadPost = (params, isShowLoading, source) => apiGET(`${BASE_URL}/brt-scene/downLoadPost`, params, isShowLoading, source, '', 'arraybuffer', 60000); // 送达书单个下载

// 批量下载文书-form表单下载
export const batchDownLoadPost = `${BASE_URL}/brt-scene/batchDownLoadPost`;
// 批量签收文书
export const signPostList = (params) => apiPOST(`${BASE_URL}/brt-scene/signPostList`, params, true);
// 签收文书
export const signPost = (params) => apiPOST(`${BASE_URL}/brt-scene/signPost`, params, true);
// 获取当前登录用户未签收的文书数量
export const getCountNotSignSize = (params) => apiGET(`${BASE_URL}/brt-scene/countNotSignSize`, params, false);

/**
 * 自助签约相关
 */
// 获取当前选中案件统计数据
export const getSelfHelpSign = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/selfHelpSign`, params, true);
// 真正发起批量自助签约
export const doSelfHelpSign = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/doSelfHelpSign`, params, false);
// 文书签字模块 - 获取当前未签字列表
export const todoSignPage = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/mediator/todoSignPage
`, params, false);
// 根据案件id获取案件附属信息，查询当前案件流程状态
export const queryMediateExtByMediateId = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/queryMediateExtByMediateId`, params, false);
// 调解员批量签字
export const signatureMediator = (params) => apiPOST(`${BASE_SERVER}/api/v1/signature/mediator`, params, false);
// 根据机构ID查询功能是否可用
export const getAccountConfigByCond = (params) => apiGET(`${BASE_SERVER}/api/v1/config/getAccountConfigByCond`, params, false);

// 阿里外呼：获取机构呼叫中心配置（复用 getAccountConfigByCond）
export const getAccountConfig = getAccountConfigByCond;
// 阿里 CCC：获取号码前缀（返回完整被叫号码）
export const getPhoneNumPrefix = (params) => apiGET(`${BASE_SERVER}/api/v1/call/getPhoneNumPrefix`, params, false);
// 阿里外呼：3.0标准 — 获取机构账户配置（含 callcenter + capabilities）
// 调用 brt-mediation-scene（新版 BFF），auth 通过 URL query params 传递
export const queryAccountConfig = () => {
  const {actId, activeRole} = store.state.user || {};
  return apiGET(`${BASE_SERVER}/api/v1/call/getCallcenterByActId`, {actId, roleId: activeRole}, false);
};

/**
 * 统计相关
 */
// 待办任务数量统计
export const todoCount = (params) => apiGET(`${BASE_SERVER}/api/v1/statistics/todoCount`, params, false);
// 发送短信前数据校验
export const preSendSms = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/preSendSms`, params, false);

/**
 * 失联修复
 */
export const queryUserByMediateId = (params) => apiGET(`${BASE_SERVER}/api/v1/repair/queryUserByMediateId`, params, true);
export const repairApply = (params) => apiPOST(`${BASE_SERVER}/api/v1/repair/apply`, params, true);
export const repairBinding = (params) => apiPOST(`${BASE_SERVER}/api/v1/repair/binding`, params, false);
export const repairUnbound = (params) => apiGET(`${BASE_SERVER}/api/v1/repair/unbound`, params, false);


//短信模板配置
export let getPageSmsTempList = (params) => apiPOST(`${BASE_SERVER_BRT}/mediation/getPageSmsTempList`, params, true);
export let saveSmsTemplate = (params) => apiPOST(`${BASE_SERVER_BRT}/mediation/saveSmsTemplate`, params, true);
export let delSmsTemplate = (params) => apiPOST(`${BASE_SERVER_BRT}/mediation/delSmsTemplate`, params, true);
export let getOneSmsTemplate = (params) => apiGET(`${BASE_SERVER_BRT}/mediation/getOneSmsTemplate`, params, true);
export let syncMdSmsTempByTempId = (params) => apiPOST(`${BASE_SERVER_BRT}/mediation/syncMdSmsTempByTempId`, params, true);
export let getCodeList = (params) => apiGET(`${BASE_SERVER_BRT}/getCodeListByPid/${params}`);
export let getSmsParamtersByType = (params) => apiGET(`${BASE_SERVER_BRT}/mediation/getSmsParamtersByType`, params);


//案号规则管理
export let getOneCaseNumRules = (params) => apiGET(`${BASE_SERVER_BRT}/mediation/getOneCaseNumRules`, params, true);
export let saveCaseNumRules = (params) => apiPOST(`${BASE_SERVER_BRT}/mediation/saveCaseNumRules`, params, true);

export let saveMediation = (params) => apiPOST(`${BASE_SERVER_BRT}/mediation/saveMediation`, params, true);
export const getMediateDefaultFuncs = (params) => apiGET(`${BASE_SERVER_BRT}/mediation/v2/getMediateDefaultFuncs`, params);
export let delMediation = (params) => apiPOST(`${BASE_SERVER_BRT}/mediation/delMediation`, params, true);

// 机构管理员-机构及账号开通
// 用户删除(删除前业务逻辑判断)
export const mdDeleteUser = (params) => apiPOST(`${BASE_SERVER_BRT}/md/user/deleteUser`, params, false);
// 用户删除-取消删除
export const cancelDeleteUser = (params) => apiPOST(`${BASE_SERVER_BRT}/md/user/cancelDeleteUser`, params, false);
// 用户删除-确认删除操作
export const doDeleteUser = (params) => apiPOST(`${BASE_SERVER_BRT}/md/user/doDeleteUser`, params, false);
// 用户迁移-校验
export const checkMigrateUserCase = (params) => apiPOST(`${BASE_SERVER_BRT}/md/case/checkMigrateUserCase`, params, false);
// 用户迁移
export const migrateUser = (params) => apiPOST(`${BASE_SERVER_BRT}/md/user/migrateUser`, params, false);
// 调解员用户迁移数据统计
export const migrateUserCaseStatistics = (params) => apiPOST(`${BASE_SERVER_BRT}/md/case/migrateUserCaseStatistics`, params, false);
// 调解机构安全策略保存
export const saveSafeStrategy = (params) => apiPOST(`${BASE_SERVER_BRT}/md/user/saveSafeStrategy`, params, false);
export const getActSafeStrategyByActId = (params) => apiGET(`${BASE_SERVER_BRT}/md/user/getActSafeStrategyByActId`, params, false);

// 机构管理员-签字规则配置
// 获取签字规则配置内容
export const getDocSignConfigByActId = (params) => apiGET(`${BASE_SERVER_BRT}/md/v2/docSing/getDocSignConfigByActId`, params, false);
// 保存签字规则
export const saveOrUpdateDocSign = (params) => apiPOST(`${BASE_SERVER_BRT}/md/v2/docSing/saveOrUpdate`, params, false);

export const getBatchEventLog = (params) => apiGET(`${BASE_SERVER}/api/v1/log/getBatchEventLog`, params, true);

// 办结提醒
export const finishStatisticsUrl = `${BASE_SERVER}/api/v1/mediate/finishStatistics`;
export const finishStatistics = (params) => apiPOST(finishStatisticsUrl, params, true);
// 批量办结
export const batchFinishUrl = `${BASE_SERVER}/api/v1/mediate/batchFinish`;
export const batchManyFinish = (params) => apiPOST(batchFinishUrl, params, true);
// 机构管理员-办结规则配置查询
export const getActCaseFinishRulesByActIdUrl = `${BASE_SERVER_BRT}/md/user/getActCaseFinishRulesByActId`;
export const getActCaseFinishRulesByActId = (params) => apiGET(getActCaseFinishRulesByActIdUrl, params, true);
// 机构管理员-签章规则配置查询
export const getActElecSignConfigByActIdUrl = `${BASE_SERVER_BRT}/md/user/getActElecSignConfigByActId`;
export const getActElecSignConfigByActId = (params) => apiGET(getActElecSignConfigByActIdUrl, params, true);
// 机构管理员-办结规则配置保存
export const saveCaseFinishRulesUrl = `${BASE_SERVER_BRT}/md/user/saveCaseFinishRules`;
export const saveCaseFinishRules = (params) => apiPOST(saveCaseFinishRulesUrl, params, true);
// 机构管理员-签章规则配置保存
export const saveElecSignConfigUrl = `${BASE_SERVER_BRT}/md/user/saveElecSignConfig`;
export const saveElecSignConfig = (params) => apiPOST(saveElecSignConfigUrl, params, true);
// 调解员-查询签章规则配置是否完整
export const validElecSignConfigComplete = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/validElecSignConfigComplete`, params, true);
// 调解员-查询当前机构是否已开启办结提醒
export const validCaseFinishRulesOpen = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/validCaseFinishRulesOpen`, params, true);

// 批量签章统计
// 获取列表
export const getBatchSignatureList = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediator/statistics/batchSignature`, params, true);
// 批量签章
export const batchSignature = (params) => apiPOST(`${BASE_SERVER}/api/v1/task/batchSignature`, params, true);


// 保融通金融纠纷案件管理系统
// 用户相关
// 获取用户信息
export const brtManagerLoginUserUrl = `${BASE_SERVER_BRT}/api/v1/stat/getLoginUser`;
export const brtManagerLoginUser = () => apiGET(brtManagerLoginUserUrl, {}, false);
// 获取用户权限
export const getStatActRightKeys = (params) => apiGET(`${BASE_SERVER_BRT}/api/v1/stat/getStatActRightKeys`, params, false);
// 修改手机号
export const brtChangePhone = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/common/doChangePhone`, params, false);
// 修改密码
export const brtChangePwd = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/common/changePwd`, params, true);
// 校验手机号是否存在
export const brtValidateUpdatePhone = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/common/validateUpdatePhone`, params, false);
// 查询调解动态配置时间段
export const queryMdStatInfoByActId = (params) => apiGET(`${BASE_SERVER_BRT}/api/v1/stat/queryMdStatInfoByActId`, params, false);
// 更新调解动态配置时间段
export const saveMdStatInfo = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/stat/saveMdStatInfo`, params, false);
// 当前统计状态
export const curCaseStatusUrl = (type) => `${BASE_SERVER_BRT_MANAGER(type)}/api/v1/case/statistics/curCaseStatus`;
export const curCaseStatus = (params) => apiPOST(curCaseStatusUrl(params.type.toLowerCase()), params, false);
// 累计案件统计
export const cumulativeCaseloadUrl = (type) => `${BASE_SERVER_BRT_MANAGER(type)}/api/v1/case/statistics/cumulativeCaseload`;
export const cumulativeCaseload = (params) => apiPOST(cumulativeCaseloadUrl(params.type.toLowerCase()), params, false);
// 案件动态
export const caseDynamicsUrl = (type) => `${BASE_SERVER_BRT_MANAGER(type)}/api/v1/case/statistics/caseDynamics`;
export const caseDynamics = (params) => apiPOST(caseDynamicsUrl(params.type.toLowerCase()), params, false);

// 签约动态
export const signedUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/signed`;
export const signed = (params) => apiGET(signedUrl, params, false);
export const querySignedDetailUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/querySignedDetail`;
export const querySignedDetail = (params) => apiPOST(querySignedDetailUrl, params, true);
export const exportSignedDetailUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/exportSignedDetail`;
export const todaySignedUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/todaySigned`;
export const todaySigned = (params) => apiPOST(todaySignedUrl, params, false);

export const querySignDetailByCaseIdUrl = `${BASE_SERVER}/api/v1/mediate/agent/querySignDetailByCaseId`;
export const querySignDetailByCaseId = (params) => apiGET(querySignDetailByCaseIdUrl, params, false);

export const exportSignedDetail = (params) => apiDownload(exportSignedDetailUrl, params, true);
// 案件总表
export const signStatisticsByBatchIdUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/signStatisticsByBatchId`;
export const signStatisticsByBatchId = (params) => apiGET(signStatisticsByBatchIdUrl, params, false);
export const querySubmitActIdByActIdUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/querySubmitActIdByActId`;
export const querySubmitActIdByActId = (params) => apiGET(querySubmitActIdByActIdUrl, params, false);
export const queryBachNameByActIdUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/queryBachNameByActId`;
export const queryBachNameByActId = (params) => apiGET(queryBachNameByActIdUrl, params, false);
export const querySubmitUserByActIdUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/querySubmitUserByActId`;
export const querySubmitUserByActId = (params) => apiGET(querySubmitUserByActIdUrl, params, false);
export const queryProcessingByPageUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/queryProcessingByPage`;
export const queryProcessingByPage = (params) => apiPOST(queryProcessingByPageUrl, params, true);
export const exportFinishDetailUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/exportFinishDetail`;
export const exportFinishDetail = (params) => apiDownload(exportFinishDetailUrl, params, true);
export const exportProcessingUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/exportProcessing`;
export const exportProcessing = (params) => apiDownload(exportProcessingUrl, params, true);

export const exportSummaryTableUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/exportSummaryTable`;
export const exportSummaryTable = (params) => apiDownload(exportSummaryTableUrl, params, true);

export const queryFinishByPageUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/queryFinishByPage`;
export const queryFinishByPage = (params) => apiPOST(queryFinishByPageUrl, params, true);
export const queryFinishDetailByPageUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/case/statistics/queryFinishDetailByPage`;
export const queryFinishDetailByPage = (params) => apiPOST(queryFinishDetailByPageUrl, params, true);

export const queryStatColJsonUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/stat/queryStatColJson`;
export const queryStatColJson = (params) => apiGET(queryStatColJsonUrl, params, false);
export const saveOrUpdateStatConfigUrl = `${BASE_SERVER_BRT_MANAGER('mediate')}/api/v1/stat/saveOrUpdateStatConfig`;
export const saveOrUpdateStatConfig = (params) => apiPOST(saveOrUpdateStatConfigUrl, params, true);

export const getCaseDetailModuleJSON = (params) => apiGET(`./static/json/case-detail-module.json?time=${new Date().getTime()}`, params, true);
export const getCaseDetailModule = (params) => apiGET(`${BASE_SERVER}/api/v1/dynamicform/queryOneConfig`, params, true);

export const queryConfigs = (params) => apiGET(`${BASE_SERVER}/api/v1/dynamicform/queryConfigs`, params, true);
// export const queryLatestFieldByActId = (params) => apiGET(`./static/json/latest-field.json`, params, true);
export const queryLatestFieldByActId = (params) => apiGET(`${BASE_SERVER}/api/v1/dynamic/field/queryLatestFieldByActId`, params, true);
export const getCaseDetailModuleData = (params) => apiGET(`./static/json/case-detail-module-data.json`, params, true);
export const saveOrUpdateDynamicform = (params) => apiPOST(`${BASE_SERVER}/api/v1/dynamicform/saveOrUpdate`, params, true);

//自定义表单相关接口
export const saveCustomFormTemplate = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v2/form/saveOrUpdateForm`, params, true);
export const customFormTemplateDetail = (params) => apiGET(`${BASE_SERVER_BRT}/api/v2/form/formDetail`, params, true);
export const getCustomFormDetail = (params) => apiGET(`${BASE_SERVER}/api/v2/form/formDetail`, params, true);

/**
 * cookie 失效拦截
 */
export function cookieInvalid(httpStatus, gw_code) {
  if ((httpStatus == 500 || httpStatus == 403) && gw_code == 401) { // cookie 失效需要重新登录
    let url = window.location.href;
    url = `${BASE_REDIRECT_URL}/api/v1/login?redirectUrl=${window.encodeURIComponent(url)}`;
    window.location.href = url;
  }
}

// 档案下载模块相关接口
// 档案打包
export const filePackUrl = `${BASE_SERVER}/api/v1/doc/pack`;
export const filePack = (params) => apiPOST(filePackUrl, params, true);
// 查询打包记录
export const getPackLogUrl = `${BASE_SERVER}/api/v1/doc/pack/query`;
export const getPackLog = (params) => apiGET(getPackLogUrl, params, false);
// 获取打包文件下载地址
export const getDownloadUrl = (params) => apiGET(`${BASE_SERVER}/api/v1/doc/pack/downloadUrl`, params, false);
export const getCasereasonConfig = (params) => apiGET(`${BASE_SERVER}/api/noauth/getCasereasonConfig`, params, false);


// 法官、书记员签名
// 查询法官、书记员的签名信息
export const getJudgeSignInfo = (params) => apiGET(`${BASE_SERVER}/api/v1/user/getUserSignOtherInfo`, params, false);
// 邀请法官、书记员签名
export const inviteJudgeSign = (params) => apiPOST(`${BASE_SERVER}/api/v1/user/saveOrUpdateUserSignOther`, params, true);
// 删除法官、书记员签名
export const deleteJudgeSign = (params) => apiPOST(`${BASE_SERVER}/api/v1/user/deleteUserSignOther`, params, true);
export const saveCallLog = (params) => apiPOST(`${BASE_SERVER}/api/v1/log/saveCallLog`, params, true);
export const callAgain = (params) => apiGET(`${BASE_SERVER}/api/v1/task/callAgain`, params, true);
export const getSalt = (params) => apiGET(`${BASE_SERVER}/api/v1/user/getSalt`, params, false);
export const verifySaltedPasswd = (params) => apiGET(`${BASE_SERVER}/api/v1/user/verifySaltedPasswd`, params, false);
export const mediateBack = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/mediateBack`, params, false);
export const agentMediateBack = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/agentMediateBack`, params, false);
export const queryBackDataCount = (params) => apiGET(`${BASE_SERVER}/api/v3/mediate/queryBackDataCount`, params, false);
export const queryBackDataPage = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/queryBackDataPage`, params, false);
export const queryBackRecordDataCount = (params) => apiGET(`${BASE_SERVER}/api/v3/mediate/queryBackRecordDataCount`, params, false);
export const queryBackRecordDataPage = (params) => apiPOST(`${BASE_SERVER}/api/v3/mediate/queryBackRecordDataPage`, params, false);
export const getBackStrategyByActId = (params) => apiGET(`${BASE_SERVER}/mediation/getBackStrategyByActId`, params, false);
export const queryFileVersionByCaseId = (params) => apiGET(`${BASE_SERVER}/api/v1/material/queryFileVersionByCaseId`, params, false);

// 失联修复工具
export const utilRepairApply = (params) => apiPOST(`${BASE_SERVER}/api/v1/repair/apply`, params, false);
export const utilApplyByRepairId = (params) => apiGET(`${BASE_SERVER}/api/v1/repair/applyByRepairId`, params, true);
export const utilRepairBatchApply = (actId, params) => apiPOST(`${BASE_SERVER}/api/v1/repair/batch/apply?actId=${actId}`, params, true);
export const utilRepairBatchBinding = (actId, params) => apiPOST(`${BASE_SERVER}/api/v1/repair/batch/binding?actId=${actId}`, params, true);
export const utilRepairBatchUnbound = (actId, params) => apiPOST(`${BASE_SERVER}/api/v1/repair/batch/unbound?actId=${actId}`, params, true);
export const utilRepairBatchDeleteById = (actId, params) => apiPOST(`${BASE_SERVER}/api/v1/repair/batchDeleteById?actId=${actId}`, params, true);

export const utilRepairBindingByRepairId = (params) => apiGET(`${BASE_SERVER}/api/v1/repair/bindingByRepairId`, params, true);
export const utilRepairUnboundByRepairId = (params) => apiGET(`${BASE_SERVER}/api/v1/repair/unboundByRepairId`, params, true);
export const utilRepairCleanUpAllExpired = (actId) => apiGET(`${BASE_SERVER}/api/v1/repair/cleanUpAllExpired?actId=${actId}`, {}, true);
export const utilRepairDeleteByRepairId = (actId, repairId) => apiPOST(`${BASE_SERVER}/api/v1/repair/deleteByRepairId?actId=${actId}&repairId=${repairId}`, {}, true);
export const utilRepairDownLoadError = (bizNo) => `${BASE_SERVER}/api/v1/repair/downLoadError?bizNo=${bizNo}`
export const utilRepairExport = (params) => apiDownload(`${BASE_SERVER}/api/v1/repair/export`, params, true);
export const utilRepairGetResourceUsage = (params) => apiGET(`${BASE_SERVER}/api/v1/repair/getResourceUsage`, params, true);
export const utilRepairImportRepair = (actId, file) => apiUpload(`${BASE_SERVER}/api/v1/repair/importRepair?actId=${actId}`, file, true);
export const utilRepairQuery = (params) => apiPOST(`${BASE_SERVER}/api/v1/repair/query`, params, true);
export const utilRepairQueryUserByMediateId = (params) => apiGET(`${BASE_SERVER}/api/v1/repair/queryUserByMediateId`, params, true);
export const utilRepairUnbound = (bindId) => apiGET(`${BASE_SERVER}/api/v1/repair/unbound?bindId=${bindId}`, {}, true);
export const utilRepairUpdateByRepairId = (params) => apiPOST(`${BASE_SERVER}/api/v1/repair/updateByRepairId`, params, true);
export const utilRepairCleanUpAllFail = (params) => apiGET(`${BASE_SERVER}/api/v1/repair/cleanUpAllFail`, params, true);
export const utilRepairGetRepairTemplateUrl = (params) => apiGET(`${BASE_SERVER}/api/v1/file/getRepairTemplateUrl`, params, true);
export const utilRepairCleanCount = (params) => apiGET(`${BASE_SERVER}/api/v1/repair/cleanCount`, params, true);
export const utilRepairQueryClrPhoneNumByActId = (params) => apiGET(`${BASE_SERVER}/api/v1/repair/queryClrPhoneNumByActId`, params, true);
export const utilRepairGetApplyProgress = (params) => apiGET(`${BASE_SERVER}/api/v1/repair/getApplyProgress`, params, true);

export const jbyBatchBack = (params) => apiPOST(`${BASE_SERVER}/api/v1/jby/fa20/actions/batchBack`, params, true);
export const jbyBatchDivision = (params) => apiPOST(`${BASE_SERVER}/api/v1/jby/fa20/actions/batchDivision`, params, true);
export const jbyBatchDivisionCheck = (params) => apiPOST(`${BASE_SERVER}/api/v1/jby/fa20/actions/batchDivisionCheck`, params, true);
export const jbyQueryMediatePage = (params) => apiPOST(`${BASE_SERVER}/api/v1/jby/fa20/actions/queryMediatePage`, params, true);
export const queryMdFirstAccountList = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/queryMdFirstAccountList`, params, true);

export const caseRegisterCount = (params) => apiPOST(`${BASE_SERVER}/api/v2/statistics/caseRegisterCount`, params, true);
export const finishCompleteCaseRegister = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/finishCompleteCaseRegister`, params, true);
export const archiveCompleteCaseRegister = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/archiveCompleteCaseRegister`, params, true);
export const subordinateDivisionCase = (params) => apiPOST(`${BASE_SERVER}/api/v1/mediate/subordinateDivisionCase`, params, true);
export const todayOverview = (params) => apiGET(`${BASE_SERVER}/api/v2/statistics/todayOverview`, params, true);
export const mediateOrgStatistics = (params) => apiPOST(`${BASE_SERVER}/api/v2/statistics/mediateOrgStatistics`, params, true);
export const financialStatistics = (params) => apiPOST(`${BASE_SERVER}/api/v2/statistics/financialStatistics`, params, true);
export const getFinishRegisterType = (params) => apiGET(`${BASE_SERVER}/api/v1/mediate/getFinishRegisterType`, params, true);
export const getSeatStatus = (params) => apiPOST(`${BASE_SERVER}/api/v1/call/v1/getSeatStatus`, params, true);
export const queryCallLogByPage = (params) => apiPOST(`${BASE_SERVER}/api/v1/log/queryCallLogByPage`, params, true);


// 字段映射

export const delBeanMaping = (params) => apiGET(`${BASE_SERVER}/api/v1/beanmapping/delBeanMaping`, params, true);
export const exportSqlByObjId = (params) => apiGET(`${BASE_SERVER}/api/v1/beanmapping/exportSqlByObjId`, params, true);
export const publishBeanMapping = (params) => apiGET(`${BASE_SERVER}/api/v1/beanmapping/publishBeanMapping`, params, true);
export const queryAllPublishBeanMapping = (params) => apiGET(`${BASE_SERVER}/api/v1/beanmapping/queryAllPublishBeanMapping`, params, true);
export const queryBeanMappingPage = (params) => apiPOST(`${BASE_SERVER}/api/v1/beanmapping/queryBeanMappingPage`, params, true);
export const queryFieldsByObjId = (params) => apiGET(`${BASE_SERVER}/api/v1/beanmapping/queryFieldsByObjId`, params, true);
export const saveBeanMapping = (params) => apiPOST(`${BASE_SERVER}/api/v1/beanmapping/saveBeanMapping`, params, true);
export const saveFields = (params) => apiPOST(`${BASE_SERVER}/api/v1/beanmapping/saveFields`, params, true);

// 自定义表单接口
export const cancelPublishFormById = (params) => apiGET(`${BASE_SERVER_BRT}/api/v2/form/cancelPublishFormById`, params, true);
export const delRelationByFormId = (params) => apiGET(`${BASE_SERVER_BRT}/api/v2/form/delRelationByFormId`, params, true);
export const generateBeanMappingByFormId = (params) => apiGET(`${BASE_SERVER_BRT}/api/v2/form/generateBeanMappingByFormId`, params, true);
export const publishFormById = (params) => apiGET(`${BASE_SERVER_BRT}/api/v2/form/publishFormById`, params, true);
export const queryFieldsByFormId = (params) => apiGET(`${BASE_SERVER_BRT}/api/v2/form/queryFieldsByFormId`, params, true);
export const queryFormRelationPage = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v2/form/queryFormRelationPage`, params, true);
export const queryFormRelationList = (params) => apiGET(`${BASE_SERVER}/api/v2/form/queryFormRelationListByActId`, params, true);
export const queryAllPublishFormRelations = (params) => apiGET(`${BASE_SERVER}/api/v2/form/queryAllPublishFormRelations`, params, true);
export const saveOrUpdateRelation = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v2/form/saveOrUpdateRelation`, params, true);
export const updateDynamicFields = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v2/form/updateDynamicFields`, params, true);
export const exportFormInfo = (params) => apiGET(`${BASE_SERVER_BRT}/api/v2/form/exportFormInfo`, params, true);
// 外呼配置接口
export let getFromDetail = (params) => apiGET(`${BASE_SERVER_BRT}/api/v1/getFromDetail`, params, false);
export let getConfigInstance = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/getConfigInstance`, params, false);
export let saveOrUpdateConfig = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/saveOrUpdateConfig`, params, false);
export let configDelete = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/config/delete`, params, false);
export let initAlibabaCCC = (params) => apiGET(`${BASE_SERVER_BRT}/api/v1/initAlibabaCCC`, params, false);

// YZW司法确认
// 导入
export let confirmationImport = (params) => apiUpload(`${BASE_SERVER}/api/v1/judicial/confirmation/async/import`, params, false);
// 导入进度
export let confirmationImportProgress = (params) => apiGET(`${BASE_SERVER}/api/v1/judicial/confirmation/async/import/progress`, params, false);
// 导出
export let confirmationExport = (params) => apiPOST(`${BASE_SERVER}/api/v1/judicial/confirmation/async/export`, params, false);
// 导出进度
export let confirmationProgress = (params) => apiGET(`${BASE_SERVER}/api/v1/judicial/confirmation/async/export/progress`, params, false);
// 删除任务
export let confirmationTaskDel = (params) => apiGET(`${BASE_SERVER}/api/v1/judicial/confirmation/async/task/del`, params, false);
// 获取任务
export let confirmationTaskGet = (params) => apiGET(`${BASE_SERVER}/api/v1/judicial/confirmation/async/task/get`, params, false);

// 法院树 - 查询法院树形数据（缓存由后端负责）
export const getCourtTreeByActId = (params) => apiGET(`${BASE_SERVER_MEDIATION}/api/v1/courtTree/tree`, params, false);

export let apiSmsMms = (params) => apiGET(`${BASE_SERVER}/api/v1/sms/mms`, params, false);
export let apiQueryBasicInfo = (params, actId) => apiGET(`${BASE_SERVER_MEDIATION}/api/v1/mediate/queryBasicInfo`, params, false);
export let apiQueryMediatorCaseByPage = (params, actId) => apiPOST(`${BASE_SERVER_MEDIATION}/api/v1/mediate/queryMediatorCaseByPage?actId=${actId}`, params, false);
export let apiGetCaseDetailByCaseId = (params, actId) => apiGET(`${BASE_SERVER_MEDIATION}/api/v1/mediate/getCaseDetailByCaseId`, params, false);
export let apiQuickSearch = (params, actId) => apiPOST(`${BASE_SERVER_MEDIATION}/api/v1/mediate/quickSearch?actId=${actId}`, params, false);

export let apiIsOpenCourtMediate = (params) => apiGET(`${BASE_SERVER_MEDIATION}/api/v1/account/isOpenCourtMediate`, params, false);
export let apiStatistics = (params) => apiGET(`${BASE_SERVER_MEDIATION}/api/v1/statistics`, params, false);
export let apiNoauthTenantConfig = (params) => apiGET(`${BASE_SERVER}/api/noauth/tenant/config`, params, false);


//案件管理员查询导出--3.0
export let apiExportCaseAdminV3 = (params, activeRole) => apiDownload(`${BASE_SERVER_MEDIATION}/api/v1/case/admin/mediate/export?actId=${params.actId || ''}&roleId=${activeRole}`, params, true)

export let apiExportCaseAdminCheckV3 = (params, activeRole) => apiPOST(`${BASE_SERVER_MEDIATION}/api/v1/case/admin/mediate/check?actId=${params.actId || ''}&roleId=${activeRole}`, params, true)

// 监管平台相关
// 删除调解机构
export const monitorDelMediation = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/monitor/delMediation`, params, true);
// 删除监管平台
export const monitorDelMonitor = (params) => apiGET(`${BASE_SERVER_BRT}/api/v1/monitor/delMonitor`, params, true);
// 用户删除-确认删除操作
export const monitorDeleteUser = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/monitor/deleteUser`, params, true);
// 获取全量监管平台
export const monitorGetAllMonitors = (params) => apiGET(`${BASE_SERVER_BRT}/api/v1/monitor/getAllMonitors`, params, true);
// 重置密码
export const monitorResetUserPwd = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/monitor/resetUserPwd`, params, true);
// 新增监管平台
export const monitorSaveMonitor = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/monitor/saveMonitor`, params, true);
// 绑定调解机构
export const monitorSaveOrUpdateMediationBind = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/monitor/saveOrUpdateMediationBind`, params, true);
// 获取监管平台与调解机构绑定信息（实时）
export const monitorGetMediationBind = (params) => apiGET(`${BASE_SERVER_BRT}/api/v1/monitor/getMediationBind`, params, true);
// 新增监管平台用户
export const monitorSaveOrUpdateMonitorUser = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/monitor/saveOrUpdateMonitorUser`, params, true);
// 修改监管平台
export const monitorUpdateMonitor = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/monitor/updateMonitor`, params, true);
// 分页获取用户列表
export const monitorGetPageUserList = (params) => apiPOST(`${BASE_SERVER_BRT}/api/v1/monitor/getPageUserList`, params, true);
// 根据id获取单个账户
export const monitorGetAccountById = (params) => apiPOST(`${BASE_SERVER_BRT}/user/getAccountById`, params, true);
// 查询金融机构绑定的监管平台信息
export const monitorGetAccountMonitorConfigByActId = (params) => apiGET(`${BASE_SERVER}/api/v1/monitor/getAccountMonitorConfigByActId`, params, true);

// ============ 案件登记码（AJDJM）============
// 生成登记码（actId 作为 query 传递，供后端 @RequestParam + 权限拦截读取）
export const ajdjmGenerate = (actId) => apiPOST(`${BASE_SERVER_BRT}/api/v1/ajdjm/generate?actId=${actId}`, {}, true);
// 查询登记码
export const ajdjmDetail = (actId) => apiGET(`${BASE_SERVER_BRT}/api/v1/ajdjm/detail`, {actId}, true);
// 删除登记码
export const ajdjmDelete = (actId) => apiPOST(`${BASE_SERVER_BRT}/api/v1/ajdjm/delete?actId=${actId}`, {}, true);

// ============ 案由树 ============
export const fetchAllCauseTypes = () => apiGET(`${BASE_SERVER_BRT}/api/v1/case-cause-type/tree`, {});
